import _ from 'lodash';
import { clearRetailerDetails, setRetailerDetails } from 'registration/actions/fetch-retailer-details.actions';
import { createAccount } from 'registration/actions/create-account.actions';
import { checkAccess } from 'app/actions/app.actions';
import { REGISTRATION_TYPE, RETAILER_TYPE } from 'app/validators/roles';
import reviewTemplate from './review-dialog.html';
import template from './self-registration.html';

const mapStateToThis = ({ session, config, registration }) => {
  const { registrationType } = config;
  const { retailer, created } = registration;

  return {
    registrationType,
    session,
    retailer,
    created,
  };
};

const mapDispatchToThis = {
  clearRetailerDetails,
  setRetailerDetails,
  createAccount,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$state', 'Notifications')
class SelfRegistrationController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.clearRegistrationFormRef = this.clearRegistrationForm.bind(this);
    this.clearRegistrationFormWithRetailerRef = this.clearRegistrationFormWithRetailer.bind(this);
    this.registrationFormModel = {};
    this.clearRegistrationFormWithRetailer();
    this.showPii = this.isNoRetailerIdRegistrationType() || this.isProspective;
    this.showRetailerNo = this.isRetailerIdRegistrationType() && !this.isProspective;

    if (this.isProspective) {
      const retailer = { retailerType: RETAILER_TYPE.PROSPECTIVE, canSelfRegister: false, canSelfRegisterProspective: true };
      this.setRetailerDetails(retailer);
    } else if (!this.checkAccess('registration.primary')) {
      this.$state.go('home-view');
    }
  }

  $onDestroy() {
    this.clearRegistrationFormWithRetailer();
    this.unsubscribe();
  }

  clearRegistrationForm() {
    this.registrationFormModel = {};
  }

  clearRegistrationFormWithRetailer() {
    this.clearRegistrationForm();
    this.clearRetailerDetails();
  }

  onSubmitRegistrationForm($event, $formCtrl) {
    $event.stopPropagation();
    $event.preventDefault();

    const resp = this.evalRegistrationForm($formCtrl);
    return resp;
  }

  evalRegistrationForm($formCtrl) {
    $formCtrl.$setSubmitted();
    $formCtrl.phone.$setTouched();
    $formCtrl.userPasswordConfirm.$validate();
    $formCtrl.confirmEmail.$validate();

    if ($formCtrl.$invalid) {
      return;
    }

    this.showReviewDialog().then(() => this.addAccount());
  }

  async addAccount() {
    await this.createAccount(this.registrationFormModel);
    if (this.created) {
      this.$state.go('registration-confirmation');
    }
  }

  showReviewDialog() {
    const data = _.cloneDeep(this.registrationFormModel);

    return this.Notifications.showComplexDialog({
      template: reviewTemplate,
      bindToController: true,
      resolve: {
        retailer: () => this.retailer,
        data: () => data,
      },
    }).result;
  }

  isRetailerIdRegistrationType() {
    return this.registrationType === REGISTRATION_TYPE.RETAILER_ID;
  }

  isNoRetailerIdRegistrationType() {
    return this.registrationType === REGISTRATION_TYPE.NO_RETAILER_ID;
  }
}

export default class SelfRegistrationComponent {
  constructor() {
    this.template = template;
    this.controller = SelfRegistrationController;
    this.bindings = {
      isProspective: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/registration/components/self-registration/self-registration/self-registration-component.js